import { takeLatest, call, select, put } from "redux-saga/effects"
import { setAIBaseRequestSuccess, setAIBaseRequestFailed, setAIBase, cleanStore } from "../actions/multiAiBase"
import { SET_AI_BASE_REQUEST } from "../types"
import { getNewAIBaseToken } from "../services/multibaseServices"
import { updateToken } from "../actions/userActions"
import { history } from "../helpers/history"
import { ROUTES } from "../utils"

function* setAIBaseRequestSaga(action) {
	try {
		const { project_id } = action.payload
		const result = yield call(getNewAIBaseToken, project_id)

		if (result.status === 200 && result.data.success === true) {
			const userData = JSON.parse(localStorage.getItem("user"))
			const newToken = result.data.token.access_token
			userData.token.access_token = newToken

			localStorage.setItem("user", JSON.stringify(userData)) //update localstorage with new token
			yield put(updateToken(userData)) //update store
			yield put(setAIBaseRequestSuccess(newToken))
			yield put(setAIBase(action.payload))
			yield put(cleanStore())
		} else {
			yield put(setAIBaseRequestFailed(result))
		}
	} catch (error) {
		yield put(setAIBaseRequestFailed(error))
	}
}

export default function* setAIBaseSaga() {
	yield takeLatest(SET_AI_BASE_REQUEST, setAIBaseRequestSaga)
}
